import { wealthProApi } from '../../redux/api';
import * as jsonpatch from 'fast-json-patch';
import { socket } from "../../redux/socket";
import { applyPatch } from 'fast-json-patch';
import _ from 'lodash';

const clientReviewApiEndpoints = wealthProApi
    .enhanceEndpoints({
        addTagTypes: ["reviews", "review"],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            fetchClientReviews: builder.query({
                query: ({ masterAccountId, page, limit }) =>
                    `api/review/MasterAccounts/${masterAccountId}/reviews?page=${page}&limit=${limit}`
            }),
            fetchClientReview: builder.query({
                query: ({ reviewId }) =>
                    `api/review/Review/GetReview/${reviewId}`,
                async onCacheEntryAdded({ reviewId }, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) {
                    try {
                        socket.emit('subscribe-review', { room: reviewId.replace(/-/gi, '') });
                        await cacheDataLoaded;

                        socket.on('on-review-update', (json) => {
                            const review = JSON.parse(json);

                            updateCachedData((data) => {
                                return {
                                    ...data,
                                    ...review
                                };
                            })
                        });

                    }
                    catch {
                    }
                    await cacheEntryRemoved;
                    socket.emit('unsubscribe-review', { room: reviewId.replace(/-/gi, '') });
                    socket.off('on-review-update');
                }
            }),
            patchClientReview: builder.mutation({
                query: ({ reviewId, operations }) => ({
                    url: `api/review/Review/${reviewId}`,
                    method: "PATCH",
                    body: operations,
                }),
                async onQueryStarted({ reviewId, operations }, { dispatch, queryFulfilled }) {
                    try {
                        const { data: review } = await queryFulfilled;
                        const reviewQuery = dispatch(wealthProApi.util.updateQueryData('fetchClientReview', { reviewId }, (data) => {
                            return review;
                        }));

                        const detailedQuery = dispatch(wealthProApi.util.updateQueryData('detailed', {}, (data) => {
                            const { results } = data || { results: [] };
                            var pagedRecord = results.find(el => el.reviewId === reviewId);
                            if (pagedRecord) {
                                applyPatch(pagedRecord, operations, true);
                                pagedRecord.assignedToValuationUser = review.assignedToValuationUser;
                                pagedRecord.assignedToDrawdownUser = review.assignedToDrawdownUser;
                                pagedRecord.assignedToAppointmentUser = review.assignedToAppointmentUser;
                                pagedRecord.preReviewDocumentAuthor = review.preReviewDocumentAuthor;
                                pagedRecord.followUpAuthor = review.followUpAuthor;
                            }
                        }));

                    }
                    catch (err) {
                        // reviewQuery.undo();
                        // detailedQuery.undo();
                    }
                },
            }),
            fetchOverwriteClientReview: builder.query({
                query: ({ reviewId }) =>
                    `api/review/Review/GetReview/${reviewId}`,
            }),
            patchOverwriteClientReview: builder.mutation({
                query: ({ reviewId, operations, overwriteComment }) => ({
                    url: `api/review/Review/overwrite/${reviewId}`,
                    method: "PATCH",
                    body: {
                        operations: operations,
                        overwriteComment: overwriteComment
                    },
                }),
                async onQueryStarted({ reviewId, operations, overwriteComment }, { dispatch, queryFulfilled }) {
                    try {
                        const { data: review } = await queryFulfilled;
                        const reviewQuery = dispatch(wealthProApi.util.updateQueryData('fetchClientReview', { reviewId }, (data) => {
                            return review;
                        }));

                        const detailedQuery = dispatch(wealthProApi.util.updateQueryData('detailed', {}, (data) => {
                            const { results } = data || { results: [] };
                            var pagedRecord = results.find(el => el.reviewId === reviewId);
                            if (pagedRecord) {
                                // applyPatch(pagedRecord, operations, true);

                                pagedRecord.isDrawdownReview = review.isDrawdownReview;

                                pagedRecord.verifiedDate = review.verifiedDate;
                                pagedRecord.verificationScore = review.verificationScore;
                                pagedRecord.assignedToValuationUser = review.assignedToValuationUser;

                                pagedRecord.preReviewDocumentScore = review.preReviewDocumentScore;
                                pagedRecord.preReviewDocumentAuthorId = review.preReviewDocumentAuthorId;
                                pagedRecord.preReviewDocumentSentDate = review.preReviewDocumentSentDate;
                                pagedRecord.preReviewDocumentStatusId = review.preReviewDocumentStatusId;
                                pagedRecord.preReviewDocumentStatusText = review.preReviewDocumentStatusText;

                                pagedRecord.appointmentScore = review.appointmentScore;
                                pagedRecord.appointmentScheduledById = review.appointmentScheduledById;
                                pagedRecord.appointmentScheduledDate = review.appointmentScheduledDate;
                                pagedRecord.appointmentStyleText = review.appointmentStyleText;

                                pagedRecord.meetingNotesUpdatedDate = review.meetingNotesUpdatedDate;
                                pagedRecord.meetingNotesScore = review.meetingNotesScore;

                                pagedRecord.followUpSentDate = review.followUpSentDate;
                                pagedRecord.followUpScore = review.followUpScore;
                                pagedRecord.followUpAuthorId = review.followUpAuthorId;
                                pagedRecord.followUpReportStatusId = review.followUpReportStatusId;
                                pagedRecord.followUpReportStatusText = review.followUpReportStatusText;
                            }
                        }));

                    }
                    catch (err) {
                        // reviewQuery.undo();
                        // detailedQuery.undo();
                    }
                },
            }),
            fetchReviewOverwriteLogs: builder.query({
                query: ({ reviewId }) => ({
                    url: `api/review/Review/overwrite/${reviewId}`,
                    method: "GET"
                })
            }),
            rearrangeClientAppointment: builder.mutation({
                query: ({ reviewId }) => ({
                    url: `api/review/review/rearrange/${reviewId}`,
                    method: "POST",
                    body: {},
                }),
                // invalidatesTags: ['review']
                async onQueryStarted(
                    { reviewId },
                    { dispatch, queryFulfilled }
                ) {
                    try {
                        var result = await queryFulfilled;
                        dispatch(
                            wealthProApi.util.updateQueryData(
                                "fetchClientReview",
                                { reviewId },
                                (review) => {
                                    return { ...review, ...result.data };
                                }
                            )
                        );
                    } catch { }
                },
            }),
            createReviewForMasterAccount: builder.mutation({
                query: ({ masterAccountId }) => ({
                    url: `api/review/review/${masterAccountId}`,
                    method: "POST",
                    body: {},
                }),
                invalidatesTags: ["reviews", "review"],
            }),
            uploadDrawDownEvidence: builder.mutation({
                query: ({ reviewId, request }) => ({
                    url: `api/review/review/documents/${reviewId}/attachments`,
                    method: 'POST',
                    body: request
                }),
                async onQueryStarted({ reviewId }, { dispatch, queryFulfilled }) {
                    try {
                        const { data } = await queryFulfilled;

                        dispatch(
                            wealthProApi.util.updateQueryData(
                                'fetchClientReview',
                                { reviewId },
                                (results) => {
                                    results.drawdownEvidenceDocuments = [...results.drawdownEvidenceDocuments, ...data];
                                }
                            )
                        );

                    }
                    catch { }
                }
            }),
            assignReviewUsers: builder.mutation({
                query: ({ request }) => ({
                    url: `api/review/review/assign`,
                    method: "POST",
                    body: request,
                }),
                async onQueryStarted({ request }, { dispatch, queryFulfilled }) {
                    try {
                        const { data: review } = await queryFulfilled;
                        const detailedQuery = dispatch(wealthProApi.util.updateQueryData('detailed', {}, (data) => {
                            const { results } = data || { results: [] };
                            var pagedRecord = results.find(el => el.reviewId === request.reviewId);
                            if (pagedRecord) {

                                pagedRecord.assignedToValuationUser = review.assignedToValuationUser;
                                pagedRecord.assignedToValuationUserId = review.assignedToValuationUserId;

                                pagedRecord.assignedToDrawdownUser = review.assignedToDrawdownUser;
                                pagedRecord.assignedToDrawdownUserId = review.assignedToDrawdownUserId;

                                pagedRecord.assignedToAppointmentUserId = review.assignedToAppointmentUserId;
                                pagedRecord.assignedToAppointmentUser = review.assignedToAppointmentUser;

                                pagedRecord.preReviewDocumentAuthor = review.preReviewDocumentAuthor;
                                pagedRecord.preReviewDocumentAuthorId = review.preReviewDocumentAuthorId;
                                pagedRecord.preReviewDocumentStatusText = review.preReviewDocumentStatusText;
                                pagedRecord.preReviewDocumentStatusId = review.preReviewDocumentStatusId;

                                pagedRecord.followUpAuthor = review.followUpAuthor;
                                pagedRecord.followUpAuthorId = review.followUpAuthorId;
                                pagedRecord.followUpReportStatusText = review.followUpReportStatusText;
                                pagedRecord.followUpReportStatusId = review.followUpReportStatusId;
                            }
                        }));

                    }
                    catch (err) {
                        // reviewQuery.undo();
                        // detailedQuery.undo();
                    }
                },
            }),
            getReviewsSummary: builder.query({
                query: ({ userIds = [] }) => _.isEmpty(userIds) 
                    ? `api/review/review/reviews-summary` 
                    : `api/review/review/reviews-summary?userIds=${_.join(userIds, '&userIds=')}`
            }),
            getClientReviewSummary: builder.query({
                query: ({masterAccountId, page, limit, cacheKey}) => ({
                    url: `api/review/review/client-summary/${masterAccountId}?page=${page}&limit=${limit}`,
                    method: 'GET',
                }),
                transformResponse: (response, _, { cacheKey }) => {
                    return { cacheKey, ...response };
                },
                serializeQueryArgs: ({endpointName, queryArgs}) => {
                    return endpointName;
                },
                merge: (currentCache, newItems) => {
                    if (_.isEqual(currentCache.cacheKey, newItems.cacheKey)) {
                        currentCache.pagination = newItems.pagination;
                        currentCache.results.push(...newItems.results);
                    }
                    else {
                        currentCache.cacheKey = newItems.cacheKey;
                        currentCache.pagination = newItems.pagination;
                        currentCache.results = [...newItems.results];
                    }             
                }
            }),
        }),
    });

export const {
    useFetchClientReviewsQuery,
    useFetchClientReviewQuery,
    useLazyFetchOverwriteClientReviewQuery,
    useLazyFetchClientReviewQuery,
    usePatchClientReviewMutation,
    usePatchOverwriteClientReviewMutation,
    useLazyFetchReviewOverwriteLogsQuery,
    useRearrangeClientAppointmentMutation,
    useCreateReviewForMasterAccountMutation,
    useUploadDrawDownEvidenceMutation,
    useAssignReviewUsersMutation,
    useGetReviewsSummaryQuery,
    useLazyGetReviewsSummaryQuery,
    useLazyGetClientReviewSummaryQuery,
} = clientReviewApiEndpoints;